import Checkbox from 'jl-design-system/components/checkbox/Checkbox';

export const TERMS_CONDITIONS = {
  termsConditions: {
    component: Checkbox,
    type: 'checkbox',
    name: 'termsConditions',
    label: 'I agree to join my John Lewis and receive communications for rewards and offers',
    id: 'ocab-terms-conditions',
    required: true,
    validationMessageKeys: {
      required: 'Please agree to the terms & conditions to continue',
    },
  },
};

export const TERMS_CONDITIONS_CONFIG = [...Object.values(TERMS_CONDITIONS)];
